import BaseClient from '@/app/model/api/response/baseApiClient'

class AccountDeleteApi extends BaseClient {
  public doAccountDelete (id: string) {
    const path: string = '/v1/master/users/' + id

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'DELETE')
  }
}

export default new AccountDeleteApi()
